<template>
  <v-card class="card-icon" v-bind="schema.attributesCard" @click="execute(schema.action)">
    <v-icon v-text="schema.attributesIcon.icon" v-bind="schema.attributesIcon"></v-icon>
    <h3 v-text="schema.attributesTitle.title" v-bind="schema.attributesTitle"></h3>

    <span v-if="isString" v-text="value" v-bind="schema.attributesDescription"></span>

    <number
      v-else
      v-bind="schema.attributesDescription"
      ref="number"
      :from="0"
      :format="theFormat"
      :to="value"
      :duration="3"
      easing="Power4.easeOut"
    />
  </v-card>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField],

  data() {
    return {
      isString: true
    };
  },

  mounted() {
    this.checkType();
  },

  methods: {
    theFormat(number) {
      return number.toFixed(0);
    },

    execute(action) {
      if (action) {
        action.mode = this.formOptions.mode;

        this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.formOptions.page });
      }
    },

    checkType() {
      if (/^[1-9]\d*(\.\d+)?$/.test(this.value)) {
        this.isString = false;
        this.$refs.number && this.$refs.number.play();
      } else {
        this.isString = true;
      }
    }
  },

  watch: {
    value(newValue, oldValue) {
      this.checkType();
    }
  }
};
</script>
<style lang="scss" scoped>
.card-icon {
  padding: 10px;
  text-align: center;
}
</style>
